import styled from "@emotion/styled";

export const CardsRow = styled.div<{ $columns?: boolean }>(({ theme, $columns }) => ({
  display: "flex",
  flexDirection: $columns ? "row" : "column",
  padding: $columns ? undefined : `${theme.spacing[2]} 0`,
  width: "100%",
  flexWrap: "wrap",
  gap: theme.spacing[5],
}));

export const TitleAndBadgeContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[2]};
  padding: ${({ theme }) => theme.spacing[2]} 0;
`;

export const SkeletonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing[2]};
`;
